import Webapi from './webapi'
import auth from '../auth'

const merchantsV1 = 'application/vnd.budbee.merchants-v1+json'

const webapi = (accept, contentType = accept) => {
    let w = new Webapi()
        .authorization(auth.get())
        .path('shopping')
        .path('admin')

    if (accept != null) {
        w.accept(accept)
    }
    if (contentType != null) {
        w = w.contentType(contentType)
    }

    return w
}

export const getCouponsListForMerchant = (merchantId) => {
    return webapi(merchantsV1, merchantsV1)
        .path('coupons')
        .queryParam('merchant-id', merchantId)
        .get()
}

export const getCouponById = (couponId) => {
    return webapi(merchantsV1, merchantsV1)
        .path('coupons')
        .path(couponId)
        .get()
}

export const createNewCoupon = (request) => {
    return webapi(merchantsV1, merchantsV1)
        .path('coupons')
        .post(request)
}

export const deleteCouponById = (couponId) => {
    return webapi(merchantsV1, merchantsV1)
        .path('coupons')
        .path(couponId)
        .delete()
}

export const updateCouponById = (couponId, request) => {
    return webapi(merchantsV1, merchantsV1)
        .path('coupons')
        .path(couponId)
        .put(request)
}
